import OrderApi from "../../../../services/api/orderApi.js";

const OrderApiService = new OrderApi();

export default {
  data() {
    return {
      carriers: [],
      order: null,
    };
  },

  methods: {
    back,
    carrierSelectCallback,
    goToReturnSlip,
    load,
    getCarriers,
    getOrder,
    updateOrderReturn,
  },

  beforeMount() {
    this.load();
  },
};

async function load() {
  /*
        get carriers first since we must ensure that they are loaded
        in order to parse order.returns properly
    */
  await this.getCarriers();

  this.getOrder();
}

function back() {
  this.$router.push({
    name: "returns",
    query: this.$route.query,
  });
}

function carrierSelectCallback(val, return_index) {
  this.order.order_returns[return_index].shipping_carrier = val.name;
}

function goToReturnSlip(isCreateNew, return_item) {
  if (isCreateNew) {
    this.$store.commit("setDataForReturnSlip", { ...this.order });
    this.$router.push("/dashboard/returns/" + this.$route.params.orderId + "/create-return-slip");
  } else {
    this.$router.push({
      name: "reviewReturnSlip",
      params: {
        orderId: this.$route.params.orderId,
        returnSlipId: return_item.id,
      },
    });
  }
}

function getCarriers() {
  const _self = this;

  return OrderApiService.getShippingCarriers()
    .then(({ data }) => {
      data.forEach((carrier) => {
        _self.carriers.push({
          name: carrier.shipping_carrier,
        });
      });
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}

function getOrder() {
  const _self = this;

  _self.$loader.$emit("trigger", true);

  OrderApiService.getOrder(_self.$route.params.orderId)
    .then((response) => {
      _self.order = response.data;
      _self.order.return_until = _self
        .$moment(_self.order.created_at)
        .add(_self.$utils.constants.DAYS_FOR_RETURN, "days");
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      _self.$loader.$emit("trigger", false);
    });
}

function updateOrderReturn(e, return_item, scope) {
  e.preventDefault();

  const _self = this;

  _self.$validator.validateAll(scope).then((valid) => {
    if (!valid) return false;

    _self.$loader.$emit("trigger", true);

    let request = {
      id: return_item.id,
      data: {
        shipping_carrier: return_item.shipping_carrier,
        shipping_cost: return_item.shipping_cost,
        tracking_number: return_item.tracking_number,
      },
    };

    OrderApiService.updateOrderReturn(request)
      .catch((error) => {
        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$logger.notify(new Error(error));
        }
      })
      .finally(() => {
        _self.$loader.$emit("trigger", false);
      });
  });
}
